/**
 * Enables card flipping functionality for elements with specified classes.
 * @module card flipping
 * @param {string} [cardClass='c-flippable-card'] - The class name for the flippable card elements.
 * @param {string} [toggleClass='c-flippable-card__toggle'] - The class name for the toggle elements that trigger the flip.
 * @param {string} [cardClassFlipped='c-flippable-card--flipped'] - The class name to be added/removed when the card is flipped.
 */
export default function enableCardFlipping(
	cardClass = 'c-flippable-card',
	toggleClass = 'c-flippable-card__toggle',
	cardClassFlipped = 'c-flippable-card--flipped'
) {
	const flippableCards = document.querySelectorAll(`.${cardClass}`);
	for (const card of flippableCards) {
		const toggles = card.querySelectorAll(`.${toggleClass}`);
		for (const toggle of toggles) {
			toggle.addEventListener('click', () => {
				card.classList.toggle(cardClassFlipped);
			});
		}
	}
}
